import React from 'react';
import * as Api from '../../../api/Api';
import { useEffect, useState, useContext } from 'react';
import { useGetToken } from '../../../Hooks/CustomHooks';
import { useQuery } from 'react-query';
import { Loading } from '../../../Components/Loading/Loading';
import { FeedbackContext } from "../../../Components/Context/FeedbackContext";
import { Modal } from 'react-bootstrap-v5';
import * as KeyNames from '../../../api/KeyNames';
import * as Utilities from '../../../Components/Utils/Utils';
import { ErrorConnection } from "../../../Components/Error/Error";

function DetalleDeuda({ setShowDetalleDeuda, idDeuda }) {

    const [detalleDeuda, setDetalleDeuda] = useState(
        {
            "codigoContrato": "",
            "nombreFantasia": "",
            "concepto": "",
            "referencia": "",
            "moneda": "",
            "saldo": 0,
            "fechaEmision": "",
            "fechaPago": "",
            "diasAtraso": 0,
            "tipoDoc": "",
            "denominacionEcoconomica": ""
        }
    );

    const token = useGetToken();
    const { feedbackContext, setFeedbackContext } = useContext(FeedbackContext);

    let { data, isLoading } = useQuery([KeyNames.SessionRespuesta, {
        idDeuda: idDeuda,
        token: token
    }],
        async () => await Api.GetDetalleDeuda(
            {
                idDeuda: idDeuda,
                token: token
            }
        ),
        {
            enabled: true
        });
    useEffect(() => {
        if (data) {
            if (data?.data === null) {
                setFeedbackContext({ ...feedbackContext, showError: true, idError: data.errorId });
            }
            else {
                setDetalleDeuda(data.data);
            }
        }
    }, [data]);

    if (isLoading) return (<Loading />)

    return (
        <Modal

            show={true}
            onHide={() => setShowDetalleDeuda(false)}
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header>
                <Modal.Title >
                    <h3>Detalle Contrato {detalleDeuda.codigoContrato} - {detalleDeuda.nombreFantasia}</h3>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='row g-9 mb-4'>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Concepto</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.concepto} disabled></input>
                    </div>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Referencia</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.referencia} disabled></input>
                    </div>
                </div>
                <div className='row g-9 mb-4'>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Moneda</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.moneda} disabled></input>
                    </div>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Saldo</label>
                        <input className="form-control" id="disabledInput" type="text" value={Utilities.comillasFix(detalleDeuda.saldo, true)} disabled></input>
                    </div>
                    {/* <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Detalle</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.detalle} disabled></input>
                    </div> */}
                </div>
                <div className='row g-9 mb-4'>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Fecha de Emisión:</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.fechaEmision} disabled></input>
                    </div>
                    <div className='col-md-6 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Fecha de Pago</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.fechaPago} disabled></input>
                    </div>
                </div>
                <div className='row g-9 mb-4'>
                    <div className='col-md-4 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Días Atrasado</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.diasAtraso} disabled></input>
                    </div>
                    <div className='col-md-8 fv-row '>
                        <label className='fs-6 fw-bold mb-2'>Tipo Documento</label>
                        <input className="form-control" id="disabledInput" type="text" value={detalleDeuda.tipoDoc} disabled></input>
                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer style={{ margin: 'auto' }}>
                <button type="button" className="btn btn-primary" onClick={() => setShowDetalleDeuda(false)}>
                    Cerrar
                </button>
            </Modal.Footer>
        </Modal >
    )
}

export default DetalleDeuda
